<template>
    <v-card>
        <v-form ref="editPremiseForm" onsubmit="return false" @submit="save">
            <v-snackbar
                    v-model="snackbars['error'].enabled"
                    :color="'primary'"
                    :timeout="2000"
                    :top="true">
                {{snackbars['error'].text}}
            </v-snackbar>
            <v-toolbar dark color="primary">
                <v-btn icon dark @click="cancel()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Edit Premises</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-tabs v-model="activeTabId">
                    <v-tab>Premise</v-tab>
                    <v-tab @click="refreshMap()">Geo-fence</v-tab>
                    <v-tab-item>
                        <v-container fluid>
                            <v-layout>
                                <v-flex md4>
                                    <v-text-field label="Name"
                                                  v-model="premise.name"
                                                  ref="premiseName"
                                                  :rules="serverValidation('name','Premise Name')"
                                                  counter="100"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex md4>
                                    <v-text-field label="Sub Name"
                                                  v-model="premise.subName"
                                                  counter="100"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 md4 v-if="$permissionHolder.hasPermission('GLOBAL_ADMIN')">
                                    <v-select :items="cadConfigurations"
                                              label="CAD Configuration"
                                              item-text="description"
                                              v-model="premise.cadConfigurationId"
                                              hint="Overrides Organization Config If Selected"
                                              persistent-hint
                                              item-value="id"></v-select>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex md9>
                                    <v-text-field label="Address"
                                                  v-model="premise.address"
                                                  counter="100"></v-text-field>
                                </v-flex>
                                <v-flex md3>
                                    <v-text-field label="Number of Floors"
                                                  type="number"
                                                  v-model="premise.numberOfFloors"
                                                  counter="100"></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex md4>
                                    <v-text-field label="Emergency Number"
                                                  type="number"
                                                  v-model="premise.emergencyNumber"
                                                  counter="100"></v-text-field>
                                </v-flex>
                                <v-flex md4 v-if="$permissionHolder.hasPermission('GLOBAL_ADMIN')">
                                    <v-text-field label="Duplicate Incident Interval"
                                                  type="number"
                                                  hint="The Number of Minutes Where Incident Requests of the Same Type / Premise Will be Treated as the Same Incident"
                                                  v-model="premise.intervalMinutes"
                                                  counter="3"></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex md6 v-if="$permissionHolder.hasPermission('GLOBAL_ADMIN')">
                                    <v-text-field label="PubliCam Token"
                                                  v-model="cameraToken"
                                                  counter="4000"></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-tab-item>
                    <v-tab-item :eager="true">
					<div style="width:100%;text-align:center" v-show="mapOverlay">
						<v-progress-circular
						    :width="3"
						    color="red"
						    indeterminate="">
						</v-progress-circular>
				    </div>
                        <div id="premiseMapContainer">
                            <div id="premiseMap" style="height:300px;height:70vh">

                            </div>
                        </div>
                    </v-tab-item>
                </v-tabs>
            </v-card-text>
            <v-card-actions>
                <v-btn outlined type="button" @click="cancel()" color="warning" :disabled="overlay">Cancel</v-btn>
                <v-btn outlined type="submit" color="success" :disabled="overlay">Save</v-btn>
                <v-progress-circular
                        :width="3"
                        v-show="overlay"
                        color="red"
                        indeterminate="">
                </v-progress-circular>
            </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>
    import api from '@/api';
    import {validationMixin} from '@/mixins/validations';
    import 'leaflet';
    import {OpenStreetMapProvider} from 'leaflet-geosearch';
    import LDraw from 'leaflet-draw'; // this is actually used please do not remove

    export default {
        mixins:[validationMixin],
        data() {
            return {
                activeTabId : 0,
                mapCenter : {},
                premiseId : null,
                cadConfigurations: [],
                map : null,
                drawControl: null,
                editableLayers: null,
                isEditingPolygon : false,
                otherPremisePointArrays : [],
                otherPremiseLayers:null,
                snackbars : {
                    'error':{enabled:false,text:'Error Saving Premise'}
                },
                points : [],
                overlay : false,
			    mapOverlay : true,
                premise : {},
                violations : [],
                originalPoints : [],
                latLngErrors : [],
                cameraToken: null,
                polygon: {
                    allowIntersection: false,
                    drawError: {
                        color: '#e1e100',
                        message: '<strong>Invalid Polygon</strong>'
                    },
                    shapeOptions: {
                        color: '#97009c'
                    }
                },
            }
        },
        mounted() {
            if (this.$permissionHolder.hasPermission('GLOBAL_ADMIN')) {
                api.cadConfig.search().then((data) => {
                    this.cadConfigurations = data.list;
                });
            }
        },
        methods : {
            refreshMap() {
                const that = this;
                if (that.map) {
                    setTimeout(function () {
                        that.map.invalidateSize();
                    },400)
                }
                return true;
            },
            open(premiseId) {
                this.reset();
                this.$root.$emit('showGlobalOverlay');
                this.premiseId = premiseId;
                this.activeTabId = 0;
                api.premise.get(this.premiseId).then((premise) => {
                    this.premise = premise;
                    api.premise.point.get(this.premiseId).then(points => {
                        this.points = points;
                        this.originalPoints = points.slice();
                        this.loadOrgPremises().then(()=> {
                            this.loadSetting().then(() => {
                                this.$nextTick(this.$refs.premiseName.focus());
                                this.geolocateAndStartInitMap();
                                this.$root.$emit('hideGlobalOverlay');
                            })
                        });
                    });

                });
            },
		   /**
		    * Gets all other premises in the organization and builds a point list for them to be displayed on the map
		    * This is so the user can prevent overlap
		    * @returns {Promise<unknown>}
		    */
		    loadOrgPremises() {
			  return new Promise((resolve,reject) => {
				  let promises = [];
				  if (this.premise.organizationId) {
					  api.premise.search({
						  organizationId: this.premise.organizationId
					  }).then((results) => {
						  let orgPremises = results.list;
						  orgPremises && orgPremises.filter((op) => {return op.id != this.premiseId}).forEach((orgPrem) => {
							  promises.push(new Promise((resolve2,reject2) => {
								  api.premise.point.get(orgPrem.id).then(points => {
									  let pArr = [];
									  points.forEach((p) => {
										  pArr.push([p.latitude,p.longitude]);
									  });
									  this.otherPremisePointArrays.push(pArr);
									  resolve2();
								  },reject2);
							  }));
						  });
						  Promise.all(promises).then(resolve,reject);
					  });
				  } else {
					  resolve();
				  }
                });
		    },
            loadSetting() {
                return new Promise((resolve,reject) => {
                   api.premise.setting.get(this.premiseId,api.constants.PUBLICAM_TOKEN).then((setting) => {
                      if (setting && setting.value) {
                        this.cameraToken = setting.value;
                      }
                      resolve();
                   });
                });
            },
            geolocateAndStartInitMap() {
                if (this.premise && this.premise.address) {
                    this.getPremiseCoordinates().then(this.initMap);
                } else {
                    this.getBrowserCoordinates().then(this.initMap);
                }
            },
            getPremiseCoordinates() {
                return new Promise((resolve,reject) => {
                    const provider = new OpenStreetMapProvider();
                    provider.search({ query: this.premise.address }).then((results) => {
                        if (results && results[0]) {
                            this.mapCenter = {
                                lat: results[0].y,
                                lng: results[0].x
                            }
                            resolve();
                        } else {
                            this.getBrowserCoordinates().then(resolve);
                        }
                    },(error) => {
                        console.error(error);
                        this.getBrowserCoordinates().then(resolve);
                    });
                });
            },
            getBrowserCoordinates() {
                const that = this;
                return new Promise((resolve,reject) => {
                    navigator.geolocation.getCurrentPosition(function (pos) {
                        let lat, lng;
                        if (pos && pos.coords) {
                            lat = pos.coords.latitude;
                            lng = pos.coords.longitude;
                        }
                        that.mapCenter = {
                            lat:lat,
                            lng:lng
                        }
                        resolve();
                    },()=> {

				});
                });
            },
            initMap() {
                const that = this;
                this.$nextTick(() => {
                    this.map = L.map('premiseMap').setView([this.mapCenter.lat,this.mapCenter.lng], 13);
                    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                        attribution: 'Map data © <a href="https://openstreetmap.org">OpenStreetMap</a> contributors',
                        maxZoom: 18,
                        id: 'mapbox.streets'
                    }).addTo(this.map);
                    this.editableLayers = new L.FeatureGroup();
				    this.otherPremiseLayers = new L.FeatureGroup();
                    if (this.points && this.points.length > 0) {
                        let pArr = [];
                        this.points.forEach((p) => {
                           pArr.push([p.latitude,p.longitude]);
                        });
                        L.polygon(pArr).addTo(this.editableLayers);
                    }

                    // add other premises - this is so we can view them and not have them overlap
                    // when creating new ones
                    this.otherPremisePointArrays.forEach((pArr) => {
                        let poly = L.polygon(pArr);
                        poly.setStyle({fillColor:'#FF0000',color:'#FF0000'});
                        poly.addTo(this.otherPremiseLayers);

                    });

                    this.map.addLayer(this.editableLayers);
				    this.map.addLayer(this.otherPremiseLayers);

                    let drawPluginOptions = {
                        position: 'topright',
                        draw: {
                            polyline: false,
                            circle: false,
                            rectangle: false,
                            marker: false,
                            circlemarker:false
                        },
                        edit: {
                            featureGroup: this.editableLayers,
                            remove: true
                        }
                    };

                    if (this.points && this.points.length > 0) {
                        drawPluginOptions.draw.polygon = false;
                    } else {
                        drawPluginOptions.draw.polygon = this.polygon;
                    }

                    this.drawControl = new L.Control.Draw(drawPluginOptions);
                    this.map.addControl(this.drawControl);



                    this.map.on('draw:created', function(e) {
                        let layer = e.layer;
                        that.editableLayers.addLayer(layer);
                        that.drawControl.setDrawingOptions({polygon:false});
                        that.map.removeControl(that.drawControl);
                        that.map.addControl(that.drawControl);
                        that.updatePointsFromGeoJSON(layer.toGeoJSON());
                    });

                    this.map.on('draw:edited', function(e) {
                        let geoJson = e.layers.toGeoJSON();
                        // for some reason, there are no layers here if the polygon was not actually edited
                        // when save was clicked. we'll check for that here to prevent any red herring JS console errors
                        if (geoJson.features.length > 0) {
                           that.updatePointsFromGeoJSON(e.layers.toGeoJSON().features[0]);
                        }
                    });

                    this.map.on('draw:editstart',(e) => {
                        this.isEditingPolygon = true;
                    });

                    this.map.on('draw:editstop',(e) => {
                        this.isEditingPolygon = false;
                    });


                    this.map.on('draw:deleted', function(e) {
                        that.drawControl.setDrawingOptions({polygon:that.polygon});
                        that.map.removeControl(that.drawControl);
                        that.map.addControl(that.drawControl);
                        that.points = [];
                    });

                    this.map.invalidateSize();
                    this.mapOverlay = false;
                });
            },
            updatePointsFromGeoJSON(json) {
                let points = [];
                for (let i=0;i<json.geometry.coordinates[0].length;i++) {
                    points.push({
                        latitude: json.geometry.coordinates[0][i][1],
                        longitude: json.geometry.coordinates[0][i][0]
                    });
                }
                this.points = points;
            },
            reset() {
                this.premiseId = null;
                this.premise = {};
                this.points = [];
                this.overlay = false;
			    this.otherPremisePointArrays = [];
			    this.otherPremiseLayers = null;
                this.violations = null;
                this.cameraToken = null;
                this.originalPoints = [];
                if (this.map) {
                    this.map.off();
                    //this.map.remove();

                    let mapEl = document.querySelector('#premiseMap');
                    let replacementEl = document.createElement('div');
                    replacementEl.id = 'premiseMap';
                    replacementEl.style.height = '70vh';
                    mapEl.remove();
                    document.querySelector('#premiseMapContainer').appendChild(replacementEl);
                }
                this.drawControl = null;
                this.editableLayers = null;

            },
            validateLatLngs() {
                let valid = true;
                if (this.points.length == 0) {
                    return true;
                }
                this.points.forEach((point) => {
                     let lat = Number(point.latitude), lng = Number(point.longitude);
                     if (isNaN(lat) || isNaN(lng)) {
                         valid = false;
                     } else {
                         if ((lat < -90 || lat > 90) || (lng < -180 || lng > 180)) {
                            valid = false;
                         }
                    }
                });
                if (!valid) {
                    this.snackbars['error'].text = 'Please Ensure Valid Lat/Lng Coordinates';
                    this.snackbars['error'].enabled = true;
                    return false;
                }

                return valid;
            },
            save() {
                const that = this;
                if (this.isEditingPolygon) {
                    alert("You Have Not Saved or Cancelled Changes To The Shape You Are Editing. Please Save/Cancel Those Changes Using the Drawing Toolbar Before Clicking Save");
                    return false;
                }
                if (!this.validateLatLngs()) {
                    return false;
                }
                this.overlay = true;
			    this.$root.$emit('showGlobalOverlay');

                const premiseToSave = JSON.parse(JSON.stringify(this.premise));

                // append our publicam URL if we're a global admin
                if (this.$permissionHolder.hasPermission('GLOBAL_ADMIN')) {
                    premiseToSave.cameraToken = this.cameraToken;
                }

                api.premise.patch(premiseToSave).then((premise) => {
                    this.savePoints().then(() => {
                        that.reset();
                        that.$emit('saved');
                        this.$root.$emit('globalMessage','Premise Saved');
                    }, (errorAndIndex) => {
                        this.snackbars['error'].text = 'Please Ensure Valid Lat/Lng Coordinates';
                        this.snackbars['error'].enabled = true;
                    });
                },(error) => {
                    if (this.processErrors(error) == this.RESPONSE_VALIDATION) {
                        this.$refs.editPremiseForm.validate();
                    }
                }).finally(() =>{
				    this.$root.$emit('hideGlobalOverlay');
                    this.overlay = false;
			    });
            },
            addPoint : function() {
                this.points.push({});
            },
            deletePoint : function(index) {
                this.points.splice(index,1);
            },
            savePoints() {
                return new Promise((resolve,reject) => {
                    api.premise.point.deleteAll(this.premiseId).then(() => {
                        api.premise.point.post(this.premiseId,this.points).then(() => {
                            resolve();
                        }, () => {
                            reject();
                        });
                    },() => {
                        reject();
                    });
                });
            },
            cancel() {
                this.reset();
                this.$emit('cancelled');
            }
        }
    }

</script>